import ImageWithText from "./ImageWithText";

export { ImageWithText };

export default ImageWithText;
